import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HorseAnalysisApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HorseAnalysisApp />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
  });
}
